import React, {Component} from "reactn";
import {Div, H1, H2, Img, Button} from "glamorous";
import { setGlobal } from 'reactn';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import data from "../../../data";
import Aux from '../../../hoc/Aux/Aux';
import Spinner from '../../common/Spinner';
import styles from "../../../styles";
import {track} from "../../../misc/utils";
import {baseURL, get} from "../../../misc/api";
import Dropdown from "react-dropdown";
import { getHeadlessRoot } from "../../../misc/utils";

class ProductSelector extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            country: null,
            locations: [],
            location: null,
            brandId: process.env.REACT_APP_BRAND_ID,
            bottles: [],
            timerId: null,
            selectedValue: null
        };

        this.onChangeHandler = this.onChangeHandler.bind(this);
        this.onSubmitHandler = this.onSubmitHandler.bind(this);
    }

    async componentDidMount() {
        this.setState({
            loading: true
        });
        let locations = [];
        const brandId = this.state.brandId;

        if (null !== this.global.selectedLocation) {
            this.getBottles(this.global.selectedLocation.value);
        } else {
            await get(baseURL + '/location/' + brandId)
                .then(response => {
                    locations = response.map(location => {
                        return {
                            value: location.locationId,
                            label: location.locationName + ' - ' + location.countryCode.toUpperCase(),
                            country: location.countryCode
                        };
                    });
                    this.setState({
                        locations: locations,
                        loading: false
                    });
                    setGlobal({
                        locations: locations
                    });
                })
                .catch(error => {
                    console.log(error);
                    alert("Unable to get locations list");

                    this.setState({
                        loading: false
                    })
                })
            ;
        }

        if (undefined !== data.journey && (data.journey.toLowerCase() === 'instore' || data.journey.toLowerCase() === 'instoreba')) {
            var timerId = setInterval(() => {
                this.setCountryFromAgeGateCookie();

                if (null !== this.state.country && null !== this.state.locations) {
                    clearInterval(timerId);
                    let filteredLocations = locations.filter(location => {
                        return location.country === this.state.country;
                    });

                    this.setState({
                        locations: filteredLocations,
                        loading: false
                    });

                    setGlobal({
                        userCountry: this.state.country,
                        locations: filteredLocations
                    });
                }
            }, 1000);

            this.setState({
                timerId: timerId
            });
        }
    }
    
    getUrlParams(url) {
      let urlStr = url.split('?')[1]
      let obj = {};
      let paramsArr = urlStr.split('&')
      for(let i = 0,len = paramsArr.length;i < len;i++){
        let arr = paramsArr[i].split('=')
        obj[arr[0]] = arr[1];
      }
      return obj
    }

    setCountryFromAgeGateCookie() {
        let found = document.cookie.split(';').filter(c => c.trim().split("=")[0] === 'diageo-gateway');
        const {agp} = this.props;
        try{
            if (agp ==='true')
              {
                const iframeSrc = window.location.href;
                const iframeParamsObj= this.getUrlParams(iframeSrc);
                const agData = iframeParamsObj['diageoGateway'];
                if(agData){
                  found = [`diageo-gateway=${agData}`];
                }
              }
          }catch(e){
            console.log('iframe error',e);
          }
        if (Array.isArray(found) && found.length > 0) {
            found = decodeURIComponent(found).split('=');
            let values = JSON.parse(found[1]);
            this.setState({
                country: values.country
            });
        }
    }

    handleProductSelect() {
        let currentSlide = this.slider.innerSlider.state.currentSlide;
        currentSlide = (currentSlide < 0) ? 0 : currentSlide;
        const bottle = this.state.bottles[currentSlide].sku;
        track.event('button', 'bottle_selected', bottle);

        this.props.setProductId(bottle);

        setGlobal({
            selectedBottleImageUrl: this.state.bottles[currentSlide].previewImageURL
        });

        this.props.setArea("Landing");
    }

    onChangeHandler(props) {
        this.setState({
            selectedValue: props
        });
    }

    getBottles(locationId) {
        let bottles = [];
        const headlessRoot = getHeadlessRoot();

        get(baseURL + '/bottles/' + this.state.brandId + '/' + locationId)
            .then(response => {
                bottles = response.map(bottle => {
                    return {
                        'sku': bottle.sku,
                        'ImageURL': headlessRoot + bottle.ImageURL,
                        'previewImageURL': headlessRoot + bottle.previewImageURL
                    }
                });
                this.setState({
                    bottles: bottles,
                    loading: false
                });
            })
            .catch(error => {
                console.log(error);
                alert("Unable to get bottles list");
                this.setState({
                    loading: false
                });
            })
        ;
    }

    onSubmitHandler = (event) => {
        event.preventDefault();
        this.setState({
            loading: true
        });

        let label = this.state.selectedValue ? this.state.selectedValue.label : this.state.locations[0].label;
        let locationId = this.state.selectedValue ? this.state.selectedValue.value : this.state.locations[0].value;

        track.event('button', 'print_destination_updated', label);

        this.getBottles(locationId);

        setGlobal({
            selectedLocation: this.state.locations.find(element => {
                return element.value === locationId;
            })
        });
    };

    render() {

        const settings = {
            className: "center  productSlider",
            centerMode: true,
            infinite: true,
            centerPadding: "0",
            slidesToShow: (this.state.bottles.length >= 3) ? 3 : this.state.bottles.length,
            slidesToScroll: 1,
            speed: 250,
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true
                    }
                }
            ],
            beforeChange: (current, next) => {
                const numberOfBottles = this.state.bottles.length;
                let direction;

                if (current === numberOfBottles - 1 && next === 0) {
                    direction = 'right'
                } else if (current === 0 && next === numberOfBottles - 1) {
                    direction = 'left'
                } else if (current < next) {
                    direction = 'right';
                } else {
                    direction = 'left';
                }
                track.event('button', 'click', `move_product_${direction}`);
            },
        };

        let dropdown;

        if (this.state.loading) {
            dropdown = <Spinner/>;
        } else if (this.state.locations.length === 0) {
            dropdown = <H2>{data.copy("productSelectorNoAccessToService")}</H2>;
        } else {
            dropdown =
                <form onSubmit={this.onSubmitHandler}>
                    <Dropdown
                        id="city"
                        placeholder="Select a city"
                        options={this.state.locations}
                        onChange={this.onChangeHandler}
                        value={this.state.locations.length === 1 ? this.state.locations[0] : this.state.selectedValue}
                    />
                    <Div marginTop="30px">
                        <Button type="submit" css={styles.ctas.preview}>
                            {data.copy("locationSelectorBtn")}
                        </Button>
                    </Div>
                </form>;
        }

        let slider = <Aux>
            <Slider ref={c => (this.slider = c)} {...settings} >
                {Object.keys(this.state.bottles).map((bottle) => (
                    <Div key={'img_' + this.state.bottles[bottle].sku} data-index={this.state.bottles[bottle].sku}
                         outline="none">
                        <Img src={this.state.bottles[bottle].ImageURL} alt=""/>
                    </Div>
                ))}
            </Slider>
            <Div marginTop="30px">
                <Button
                    css={styles.ctas.preview}
                    onClick={() => {
                        this.handleProductSelect();
                    }}>
                    {data.copy("productSelectorBtn")}
                </Button>
            </Div>
        </Aux>;

        return (
            <Div className="container container--generic">
                <Div css={styles.generic}>
                    <H1>{this.state.bottles.length > 0 ? data.copy("productSelectorTitle") : data.copy("productSelectorSelectLocation")}</H1>
                    {(this.state.bottles.length > 0) ? slider : dropdown}
                </Div>
            </Div>
        );
    }
}

export default ProductSelector;



// WEBPACK FOOTER //
// ./src/components/areas/ProductSelector/index.js